import { Component, ChangeDetectionStrategy, DestroyRef, inject, signal, computed, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from '../../core/services/auth';
import { DashboardResponse, DashboardService } from '../../core/services/dashboard';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [DatePipe, RouterLink],
  templateUrl: './dashboard.html',
  styleUrl: './dashboard.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardComponent implements OnInit {
  private dashboard = inject(DashboardService);
  private auth = inject(AuthService);
  private destroyRef = inject(DestroyRef);

  data = signal<DashboardResponse | null>(null);
  loading = signal(true);
  error = signal<string | null>(null);

  private roles = computed(() => (this.auth.currentUser()?.roles as string[] | undefined) ?? []);
  showRuns = computed(() => this.roles().includes('admin') || this.roles().includes('super_admin'));
  showSync = computed(() => this.roles().includes('super_admin'));
  cardCount = computed(() => 2 + (this.showRuns() ? 1 : 0) + (this.showSync() ? 1 : 0));

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading.set(true);
    this.error.set(null);
    this.dashboard.load().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (data) => {
        this.data.set(data);
        this.loading.set(false);
      },
      error: (err) => {
        this.error.set(err?.error?.detail ?? 'Could not load the dashboard.');
        this.loading.set(false);
      },
    });
  }

  syncHeadline(): string {
    const status = this.data()?.last_sync?.status;
    if (!status) return 'None';
    return status.replaceAll('-', ' ');
  }
}
